export default "__VITE_ASSET__DQfJseAD__"